module.exports = __webpack_public_path__ + "static/media/logo.de2f4b9a.png";